import { render, staticRenderFns } from "./Ekaf.vue?vue&type=template&id=45981e6c&scoped=true"
import script from "./Ekaf.vue?vue&type=script&lang=js"
export * from "./Ekaf.vue?vue&type=script&lang=js"
import style0 from "./Ekaf.vue?vue&type=style&index=0&id=45981e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45981e6c",
  null
  
)

export default component.exports